import { InputNumber, Space } from 'antd';
import { useSearchParams } from 'react-router-dom';

import SearchParam from '../SearchParam';
import FilterButton from './FilterButton';

interface FilterRangeProps {
  nameMin: string;
  nameMax: string;
}

const FilterRange = ({ nameMin, nameMax }: FilterRangeProps) => {
  const [searchParams] = useSearchParams();

  return (
    <Space direction="vertical">
      <Space direction="horizontal">
        <SearchParam name={nameMin} onSetSearchParams={{ page: '1' }}>
          <InputNumber data-testid="start-filter-range-input" min={0} max={100} />
        </SearchParam>
        até
        <SearchParam name={nameMax} onSetSearchParams={{ page: '1' }}>
          <InputNumber data-testid="end-filter-range-input" min={0} max={100} />
        </SearchParam>
      </Space>
      <SearchParam
        array
        name={nameMin}
        onSetSearchParams={{ page: '1', [nameMax]: '' }}
        valuePropName="disabledValue"
      >
        <FilterButton disabled={!(searchParams.get(nameMin) || searchParams.get(nameMax))}>
          Limpar
        </FilterButton>
      </SearchParam>
    </Space>
  );
};

export default FilterRange;
